export const getInitialState = () => ({
  data: {
    unitsList: [],
    selectedUnit: {},
    unitConfigs: {},
    currentBrand: {
      brandName: null,
      brandId: null,
    },
    currentUnit: {
      unitName: null,
      unitId: null,
    },
  },
});

export const state = getInitialState();
